module.exports = __webpack_public_path__ + "img/building-wall-panels-0.120e67f3.jpeg";